import { createClient } from '@supabase/supabase-js'

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || 'https://orttxalhystwbhckuera.supabase.co'
const supabaseKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9ydHR4YWxoeXN0d2JoY2t1ZXJhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgzMjc3ODQsImV4cCI6MjA3MzkwMzc4NH0.HnAub0BJjGjis77rvAzhUF7WsGwvjQ25ZGOPj6vhTjE'

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})
